import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import LzSApp from '@lz-app/App';
import lzSLayoutNavItemsAtom from '@lz-atoms/Layout/navItems';
import { lzFBuildRouter } from '@lz/services/Routes';
import LzPAppBootstrap from './type';

export default function LzXAppBootstrapConclude(props: LzPAppBootstrap) {
    // Store state getters and setters
    const setLayoutNavItemsState = useSetAtom(lzSLayoutNavItemsAtom);

    // Build the routes and navs
    const [routes, navItems] = LzSApp.buildRoutesAndNavs(props);

    // Set the nav items to the store
    useEffect(() => {
        setLayoutNavItemsState(navItems);
    }, [navItems]);

    // Show children as single component if provided
    if (props.children) {
        return <React.Fragment>{props.children}</React.Fragment>;
    }

    // If routes exist
    if (routes.length > 0) {
        return <React.Fragment>{lzFBuildRouter(routes)}</React.Fragment>;
    }

    // Nothing specified means some miss-configuration
    return <React.Fragment>...must define routes, modules or child component...</React.Fragment>;
}
